import React from "react";
import PropTypes from "prop-types";
import * as Theme from "../../../app/Theme";
// import Menu from "@material-ui/core/Menu/Menu";
// import MenuItem from "@material-ui/core/MenuItem/MenuItem";
// import IconButton from "@material-ui/core/IconButton/IconButton";
// import DotsMenu from "@material-ui/icons/MoreVert";
// import JohnsHopkinsSPHLogo from "../../../img/JohnsHopkinsSPHLogo.png";
// import TButton from '../../common/TButton';
// import TBox from "../../common/TBox";
// import TDialog from "../../common/TDialog";
// import TLabel from "../../common/TLabel";
// import * as HLConst from "../NonVisual/HLConst";
// import * as HLUtil from "../NonVisual/HLUtil";
// import Banner from "../../../img/banner.jpg";

//const portalMenuItem = 1;
const resourcesMenuItem = 1;
const aboutMenuItem = 2;

//const portalBtnHideWidth = 890;
// const resourcesBtnHideWidth = 910;
// const aboutBtnHideWidth = 960;

class HLAppBarCustom extends React.Component {
    //==================================================================================================================
    //
    //                                             Props and State
    //
    //==================================================================================================================

    static propTypes = {
        onDrawerChange: PropTypes.func,
        pageID: PropTypes.string,
        onPageChange: PropTypes.func,
        // showAboutDialog                 : PropTypes.bool,
        // onShowAboutDialogChange         : PropTypes.func,
    };

    static defaultProps = {
        onDrawerChange: () => console.log("onDrawerChange"),
        pageID: "",
        onPageChange: () => console.log("onPageChange"),
        // showAboutDialog                 : false,
        // onShowAboutDialogChange         : () => console.log("onShowAboutDialogChange"),
    };

    state = {
        fileAnchor: null,
        windowInnerWidth: 0,
    };

    componentDidMount() {
        this.onResize();
        window.addEventListener("resize", this.onResize);
    }

    componentWillUnmount() {
        window.removeEventListener("resize", this.onResize);
    }

    getButtonStyle = (buttonEnabledBool, pageIDStr) => {
        let style;

        if (buttonEnabledBool) {
            if (this.props.pageID === pageIDStr) {
                style = Theme.styles.buttonSelectedLab;
            } else {
                style = Theme.styles.buttonLab;
            }
        } else {
            style = Theme.styles.buttonDisabledLab;
        }

        return style;
    };

    //==================================================================================================================
    //
    //                                              Event Handlers
    //
    //==================================================================================================================

    /* By making the inner width state and setting it when the screen resizes, we can update the app bar controls
       based on the width of the screen. */
    onResize = () => {
        this.setState({
            fileAnchor: null,
            windowInnerWidth: window.innerWidth,
        });
    };

    onPageChange = (id) => {
        try {
            this.props.onPageChange(id);
        } catch (exception) {}
    };

    // onAboutBtnClick = () => {
    //
    //     this.props.onShowAboutDialogChange(true);
    //
    // };
    //
    // onAboutDialogClose = () => {
    //
    //     this.props.onShowAboutDialogChange(false);
    //
    // };

    handleFileBtnClick = (event) => {
        this.setState({
            fileAnchor: event.currentTarget,
        });
    };

    handleFileBtnClose = () => {
        this.setState({
            fileAnchor: null,
        });
    };

    onDotMenuItemClick = (menuItemByte) => {
        this.setState(
            {
                fileAnchor: null,
            },
            () => {
                switch (menuItemByte) {
                    case aboutMenuItem:
                        this.onAboutBtnClick();
                        break;

                    case resourcesMenuItem:
                        break;

                    //case portalMenuItem :
                    //    this.onPageChange(HLConst.portalForm);
                    //    break;

                    default:
                        break;
                }
            }
        );
    };

    //==================================================================================================================
    //
    //                                                 Render
    //
    //==================================================================================================================

    render() {
        // const fileAnchor = state.fileAnchor;
        // const windowInnerWidth = state.windowInnerWidth;

        //let portalBtn = null;
        //let portalMenuItemClick = null;
        // let resourcesBtn = null;
        // let resourcesMenuItemClick = null;
        // let aboutBtn = null;
        // let aboutMenuItemClick = null;
        // let dotsMenuDiv = null;

        // if (windowInnerWidth > portalBtnHideWidth) {
        //
        //     portalBtn =
        //         <TButton
        //             caption        = {"Portal"}
        //             captionStyles  = {{
        //                 color          : Theme.blackColor,
        //                 ...Theme.menuItemFontStyle,
        //                 fontSize       : 16,
        //                 textDecoration : "underline",
        //             }}
        //             key            = {"portalBtn"}
        //             transparent    = {true}
        //             //containerStyle = {{float : "right"}}
        //             onClick        = {() => this.onPageChange(HLConst.portalForm)}
        //         />;
        //
        // }
        // else {
        //
        //     portalMenuItemClick =
        //         <MenuItem
        //             onClick = {() => this.onDotMenuItemClick(portalMenuItem)}
        //         >
        //             Portal
        //         </MenuItem>;
        //
        // }

        // if (windowInnerWidth > resourcesBtnHideWidth) {
        //
        //     resourcesBtn =
        //         <TButton
        //             caption        = {"Resources"}
        //             captionStyles  = {{
        //                 color          : Theme.blackColor,
        //                 ...Theme.menuItemFontStyle,
        //                 fontSize       : 16,
        //                 textDecoration : "underline",
        //             }}
        //             key            = {"resourcesBtn"}
        //             transparent    = {true}
        //             //containerStyle = {{float : "right"}}
        //             onClick        = {() => alert("Not yet available.")}
        //         />;
        //
        // }
        // else {
        //
        //     resourcesMenuItemClick =
        //         <MenuItem
        //             onClick = {() => alert("Not yet available.")}
        //         >
        //             Resources
        //         </MenuItem>;
        //
        // }

        // if (windowInnerWidth > aboutBtnHideWidth) {
        //
        //     aboutBtn =
        //         <TButton
        //             caption        = {"About"}
        //             captionStyles  = {{
        //                 color          : Theme.blackColor,
        //                 ...Theme.menuItemFontStyle,
        //                 fontSize       : 16,
        //                 textDecoration : "underline",
        //             }}
        //             key            = {"aboutBtn"}
        //             transparent    = {true}
        //             //containerStyle = {{float : "right"}}
        //             onClick        = {this.onAboutBtnClick}
        //         />;
        //
        // }
        // else {
        //
        //     aboutMenuItemClick =
        //         <MenuItem
        //             onClick = {() => this.onDotMenuItemClick(aboutMenuItem)}
        //         >
        //             About
        //         </MenuItem>;
        //
        //     const dotsMenuBtn =
        //         <IconButton
        //             aria-label    = "Menu"
        //             aria-owns     = {fileAnchor ? 'file-menu' : null}
        //             aria-haspopup = "true"
        //             color         = {"secondary"}
        //             onClick       = {this.handleFileBtnClick}
        //         >
        //             <DotsMenu/>
        //         </IconButton>;
        //
        //     const dotsMenu =
        //         <Menu
        //             id                 = "file-menu"
        //             anchorEl           = {fileAnchor}
        //             open               = {Boolean(fileAnchor)}
        //             onClose            = {this.handleFileBtnClose}
        //             getContentAnchorEl = {null}
        //             anchorOrigin       = {{
        //                 vertical   : 'bottom',
        //                 horizontal : 'left',
        //             }}
        //         >
        //             {/*{portalMenuItemClick}*/}
        //             {resourcesMenuItemClick}
        //             {aboutMenuItemClick}
        //
        //         </Menu>;
        //
        //     dotsMenuDiv =
        //         <div
        //             style = {{
        //                 display : 'inline-block',
        //             }}
        //         >
        //             {dotsMenuBtn}
        //             {dotsMenu}
        //         </div>;
        //
        // }

        // let aboutDialog = null;
        //
        // if (this.props.showAboutDialog) {
        //
        //     const JHSPH_Img =
        //         <div
        //             key   = {"JHSPH_ImgDiv"}
        //             style = {{
        //                 display        : "flex",
        //                 justifyContent : "center",
        //                 width          : "100%",
        //             }}
        //         >
        //             <img
        //                 alt   = ""
        //                 key   = {"JHSPH_Img"}
        //                 src   = {JohnsHopkinsSPHLogo}
        //                 style = {{
        //                     width     : 200,
        //                 }}
        //             />
        //         </div>;
        //
        //     const welcomePageText =
        //         <h5>
        //             Welcome page image:
        //         </h5>;
        //
        //     const creditText =
        //         <h6 style = {{marginLeft : 20}}>
        //             "Portrait of massai kids. Girls, girl."
        //             <br/>
        //             ID 93017741 © chehade foz | Dreamstime.com
        //         </h6>;
        //
        //     let dialogContent = [];
        //     dialogContent.push(JHSPH_Img);
        //     dialogContent.push(welcomePageText);
        //     dialogContent.push(creditText);
        //
        //     aboutDialog =
        //         <TDialog
        //             actions = {["mrClose"]}
        //             onClose = {this.onAboutDialogClose}
        //             content = {dialogContent}
        //             key     = {"aboutDialog"}
        //         />;
        //
        // }

        // const btnDiv =
        //     <div
        //         key   = {"btnDiv"}
        //         style = {{
        //             float : "right",
        //         }}
        //     >
        //         {resourcesBtn}
        //         {aboutBtn}
        //         {dotsMenuDiv}
        //     </div>;

        return (
            <div
                key={"HLAppBarCustomDiv"}
                style={{
                    width: "100%",
                }}
            >
                {/*{btnDiv}*/}
                {/*{aboutDialog}*/}
            </div>
        );
    }
}

export default HLAppBarCustom;
